import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// 모바일 디버깅을 위한 전역 에러 핸들러 추가
window.onerror = function(message, source, lineno, colno, error) {
    alert('JS Error: ' + message + '\nLine: ' + lineno + '\nSource: ' + source);
    return false;
};

window.onunhandledrejection = function(event) {
    alert('Promise Error: ' + event.reason);
};

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// [V2.5] Service Worker 강제 해제 및 캐시 삭제 (강력한 새 배포 반영을 위함)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

// 모든 캐시 저장소 삭제
if ('caches' in window) {
  caches.keys().then(names => {
    for (const name of names) caches.delete(name);
  });
}
